import Subheading from 'components/Subheading';

const ImageWithContentSection = ({ subheadingText, imageSrc, imageAltText, reverseDesktopDirection = false, children }) => (
  <div className="imageWithContentSectionContainer">
    <div className="contentSide">
      <div className="contentContainer">
        <div className="paddedMaxWidthContainer">
          <Subheading>
            { subheadingText }
          </Subheading>

          { children }
        </div>
      </div>
    </div>

    <img
      className="image"
      src={imageSrc}
      alt={imageAltText}
    />

    <style jsx>
      {`
        .imageWithContentSectionContainer {
          width: 100%;
          display: flex;
          flex-direction: ${reverseDesktopDirection ? 'row' : 'row-reverse'};
        }
        
        .image {
          object-fit: cover;
          height: 100%;
        }
        
        @media(min-width: 1200px) {
          .image {
            max-height: 700px;
          }
        }
        
        .imageWithContentSectionContainer>* {
          width: 50%;
        }
        
        .contentSide {
          display: flex;
          justify-content: ${!reverseDesktopDirection ? 'flex-start' : 'flex-end'};
          align-items: center;
        }
        
        :global(.ctaContainer), :global(.imageWithContentSectionContainer .subheading) {
          width: 100%;
          text-align: left;
        }
        
        :global(.ctaContainer) {
          margin: 2em 0;
        }
        
        .paddedMaxWidthContainer {
          margin: auto;
          align-items: flex-start;
          padding: 40px 2em 75px;
          max-width: 500px;
        }
        
        @media(max-width: 800px) {
          .paddedMaxWidthContainer {
            padding-left: 0.5em;
            padding-right: 0.5em;
            padding: 40px 1em;
          }
          
          .image {
            // Fixes bug on physical iOS device where parent section was filled in image.
            height: auto;
            max-height: 300px;
          }
          
          .imageWithContentSectionContainer {
            flex-direction: column-reverse;
          }
          
          .imageWithContentSectionContainer>* {
            width: 100%;
          }
          
          .contentContainer {
            margin: 0 auto;
          }
          
          :global(.ctaContainer), :global(.imageWithContentSectionContainer .subheading) {
            text-align: center;
          }
        }
      `}
    </style>
  </div>
);

export default ImageWithContentSection;
